<template>
  <div id="doubtView">
  	<div class="solution-wrapper">
      <span v-if="current_doubt.doubt_status=='completed'" class="green-bg solved">Solved &#10003;</span>
      <span v-else class="yellow-bg unsolved">Pending!</span>
  		<h5 style="margin-top:10px">{{current_doubt.title}}</h5>
      <p>{{current_doubt.description}}</p>
      
      <div v-if="current_doubt.attachment_filename != '' && current_doubt.attachment_filename != null">
        <p>Your attachment:</p>
        <loader v-if="attachment_filename != '' && img_source== ''"></loader>
        <img :id="'doubt_image'+current_doubt.id" :src="img_source" style="width:100%; display:block;"  @click="open_image('doubt_image'+current_doubt.id)" />
      </div>
      
      <div>

        <div v-if="current_doubt.doubt_status=='completed'">
          <h4 style="margin-top:20px">Solution:</h4>
          <p>{{solution.description}}</p>
        </div>

        <loader v-if="solution.attachment_filename != null && solution_img_source == ''"></loader>
        <div v-if="solution_img_source != ''">

          <img :id="'solution_image'+current_doubt.id" :src="solution_img_source" style="width:100%; display:block;" @click="open_image('solution_image'+current_doubt.id)"/>
        </div>

        <!-- Show rating -->
        <b-card title="Rate the solution">
          <star-rating star-size="30" v-model="solution_rating"></star-rating>
        </b-card>
        <!-- Show notepad -->
        <div v-if="current_doubt.doubt_status=='completed'" style="margin-top:20px;background-color:white;padding:20px">
          
            <h2>Your Note:</h2>
            <p>You can view all your notes in the Notepad section.</p>
            <b-form-textarea id="textarea1"
                         v-model="current_doubt.note_text"
                         placeholder="Type your note here"
                         :rows="3"
                         :max-rows="6">
            </b-form-textarea>
            
            <b-button class="btn query-btn button-touchy" variant="primary" style="margin-top: 20px; margin-left:0; max-width:100px" @click="execute_save_note">Save</b-button>
            </div>
        </div>
      </div>
  		
  	</div>
  </div>
</template>

<script>
import dropdown from 'vue-my-dropdown';
import StarRating from 'vue-star-rating'
import moment from 'moment';
import _ from 'lodash';
import loader from '../Loader.vue';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';

var viewer = null;

export default {
  name: 'DoubtView',
  components: {
    loader,
    StarRating
  },
  data () {
    return {
      msg: 'Welcome to QdsPro',
      the_doubt: {
      	title:'',
      	description:'',
      	created_at:'',
      	doubt_status:'',
      	solution: null,
      	attachment_filename:''
      },
      img_source:'',
      solution:{},
      solution_img_source:'',
      solution_rating:''
    }
  },
  mounted: async function() {
    if(this.current_doubt.attachment_filename != null) {
      this.get_attachment();
    }

    if(this.current_doubt.doubt_status == 'completed') {
      this.get_solution();
      this.get_solution_attachment();
      
    }
  },
  destroyed: function() {
    viewer.hide();
    console.log('closed');
  },
  computed: {
    user: function() {
      return this.$store.getters.user
    },
    current_doubt: function() {
    	var doubt_id = this.$route.params.id;
      //return this.$route.params.id;
    	return _.find(this.user.doubts, {'id':Number(doubt_id)});
    }
  },
  methods: {
    open_image(id) {
      console.log(id);
      viewer = new Viewer(document.getElementById(id), {
        ready() {
          viewer.show();  
        },
        viewed() {
          //viewer.zoomTo(1);
        },
        navbar:false,
        title:false,
        toolbar: {
          zoomIn:false,
          zoomOut:false,
          oneToOne:false,
          reset:false,
          play:false,
          next:false,
          flipHorizontal:false,
          flipVertical:false,
          rotateLeft: true,
          rotateRight: true,
        }
      });

      viewer.show();


    },
    get_human_date(d) {
      let mom = moment(d);
      return mom.format('LL');
    },
    async get_attachment() {
      var action = await this.$store.dispatch('fetch_doubt_attachment',this.current_doubt.id);

      //var attachment = action.data;

      var attachment = action.data.data;

      var source  = 'data:'+ attachment.attachment_type + ';base64,'+ attachment.attachment_data;

      this.img_source = source;
      
    },
    async get_solution() {
      var action = await this.$store.dispatch('fetch_doubt_solution', this.current_doubt.id);

      this.solution = action.data.data[0];
      this.solution_rating = this.solution.rating;
    },
    async get_solution_attachment() {

      try {
        var action = await this.$store.dispatch('fetch_doubt_solution_attachment',this.current_doubt.id);

        

        var attachment = action.data.data;

        var source  = 'data:'+ attachment.attachment_type + ';base64,'+ attachment.attachment_data;

        this.solution_img_source = source;

      } catch(ex) {
        console.log(ex.toString());
      }
      
    },
    async execute_save_note() {
      var data = {
        doubt_id: this.current_doubt.id,
        text: this.current_doubt.note_text
      }
      var action = await this.$store.dispatch('save_doubt_note', data);
      this.$toasted.show('Note Saved!',{type:'success'});
    }
  },
  watch: {
    $route(to,from) {
      this.get_attachment();
      this.get_solution();
    },
    solution_rating: function(to,from) {
      if(this.solution.rating == this.solution_rating) {
        return;  
      } else {
        this.$store.dispatch('rate_solution',{doubt_id:this.current_doubt.id, rating: this.solution_rating}); 
        this.$toasted.show("Thanks 👍", {type:'success'});
      }
      
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.date {
  font-size: 0.8rem;
}
.solution-header {
	margin: 30px 0;
}
#solutions .custom-select,.sol-filter .form-control,.query-btn {
	border-radius: 20px;
	font-size: .8rem;
	line-height: 1.6rem;
}
.query-btn {
	width: 100%;
}
.sol-rating {
	display: inline-flex;
	justify-content: space-evenly;
	align-items: center;
}
.solution-link {
	background-color: #fff;
	margin: 10px 0px;
	display: block;
	color: #ffce00;
	padding: 20px;
}
.solution-link p {
	margin: 0;
}
.star-rating {
  line-height:32px;
  font-size:1.25em;
}
.sol-view {
	font-size: 3rem;
	line-height: 3rem;
	text-align: right;
}
.text-center {
	text-align: center;
}
.solution-link {
	border-left: 5px solid;
	border-color: #959090;
}
.qds-active-border {
	border-color:  #AACF37;
}

.doubt-description {
    display: none;
}

.green-bg.solved {
  background-color: #77bf43;
  padding: 5px;
  display: inline-block;
  box-shadow: 0px 1px 15px 1px rgba(69,65,78,0.3);
  border-radius: 5px;

}
.yellow-bg.unsolved {
  background-color: #ffce00;
  padding: 5px;
  display: inline-block;
  box-shadow: 0px 1px 15px 1px rgba(69,65,78,0.1);
  border-radius: 5px;

}

@media screen and (min-width: 1280px) {
  .doubt-description {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/DoubtView.vue